// "Copiar link" button: copies the match link to the clipboard and shows a short "Link copiado" feedback.
import React, { useState } from "react";

const ShareMatchButton = ({ url, className = "r-btn-soft" }) => {
	const [copied, setCopied] = useState(false);
	const copy = async () => {
		try {
			await navigator.clipboard.writeText(url);
			setCopied(true);
			setTimeout(() => setCopied(false), 2500);
		} catch (_) {
			// Clipboard unavailable or denied: stay silent, the button keeps its label.
		}
	};
	return (
		<button type="button" className={className} onClick={copy}>
			{copied ? "Link copiado" : "Copiar link"}
		</button>
	);
};

export default ShareMatchButton;
